import localeText from "../../locale";
import { PLATFORM_PRODUCT_FEE } from "../../utilities/constants";
import { formatPrice } from "../../utilities/formatPrice";
import { getLocale } from "../../utilities/locale/locale";

const CURRENCY_SYMBOLS = { EUR: "€", USD: "$", GBP: "£", BRL: "R$" };

export const money = (value, currency = "EUR") => {
  const symbol = CURRENCY_SYMBOLS[currency] || currency;
  return `${symbol} ${formatPrice(Number(value || 0))}`;
};

// Preco mostrado ao comprador: com a taxa de servico, como no marketplace (o servidor cobra itens + 5%)
export const withFee = (price) => Number(price || 0) * (1 + PLATFORM_PRODUCT_FEE);

export const productUnitPrice = (product, variation) => {
  if (variation?.price) return Number(variation.price);
  if (product?.promotionalPriceUnique > 0) return Number(product.promotionalPriceUnique);
  return Number(product?.priceUnique || 0);
};

export const percentText = (value) => {
  const number = Number(value || 0);
  return Number.isInteger(number) ? String(number) : formatPrice(number);
};

const CATEGORY_FIELD = {
  it: "descriptionItalian",
  en: "descriptionEnglish",
  pt: "descriptionPortuguese",
  es: "descriptionSpanish",
};

export const categoryName = (category) =>
  category?.[CATEGORY_FIELD[getLocale()]] || category?.descriptionItalian || category?.descriptionEnglish || "";

const LANGUAGE = { it: "ITALIAN", en: "ENGLISH", pt: "PORTUGUESE", es: "SPANISH" };

export const buyerLanguage = () => LANGUAGE[getLocale()] || "ITALIAN";

// Texto do erro de uma resposta { messageCode, message } do backend (ou de uma excecao do axios)
export const errorText = (response) => {
  const code = response?.messageCode || response?.response?.data?.messageCode;

  if (code) {
    const own = localeText(`channelError${code}`);
    if (own) return own;

    const shared = (localeText("data") || []).find?.((item) => item.code === code);
    if (shared?.message) return shared.message;
  }

  return localeText("channelGenericError");
};

// 500419 traz o id do produto na mensagem ("Product 123 can not be sold ...")
export const unavailableProductId = (response) => {
  if (response?.messageCode !== 500419) return null;
  const match = /Product (\d+)/.exec(response?.message || "");
  return match ? Number(match[1]) : null;
};

export const isOk = (response) => response?.messageCode === 200000;
